module.exports = new __parcel__URL__("Error.6b090a72.svg").toString();